import { isPlatformBrowser } from '@angular/common';
import {
  Directive, ElementRef, Inject, Input, OnDestroy, PLATFORM_ID, AfterViewInit, OnInit, SimpleChanges, OnChanges
} from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { LazyLoadObserverService } from './lazy-load-observer.service';
import { LazyDataInterface } from './lazy-load.interface';


@Directive({
  selector: '[lazyPoster]'
})
export class LazyPosterDirective implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() public preRender: boolean = true;
  @Input() public lazyPoster: LazyDataInterface | undefined = undefined;

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private isLazyLoaded: boolean = false;

  constructor(
    private readonly element: ElementRef,
    private readonly lazyLoadObserverService: LazyLoadObserverService,
    @Inject(PLATFORM_ID) private readonly platformId: Record<string, unknown>
  ) {}

  public ngOnInit() {
    const url = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${this.lazyPoster?.width} ${this.lazyPoster?.height}"%3E%3C/svg%3E`;
    this.element.nativeElement.setAttribute('poster', url);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (!!changes.lazyPoster
      && !changes.lazyPoster.isFirstChange()
      && this.isLazyLoaded
      && changes.lazyPoster.currentValue?.src.split('?')[0] !== changes.lazyPoster.previousValue?.src.split('?')[0]
    ) {
      this.load();
    }
  }

  public ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) {
      if (this.preRender) {
        this.load();
        return;
      }
    }

    this.lazyLoadObserverService.observeElement(this.element.nativeElement).pipe(
      takeUntil(this.ngUnsubscribe),
      take(1)
    ).subscribe(() => {
      this.load();
      this.isLazyLoaded = true;
    });
  }

  public ngOnDestroy() {
    this.lazyLoadObserverService.unobserveElement(this.element.nativeElement);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private load(): void {
    this.element.nativeElement.style.minHeight = 'auto';
    this.element.nativeElement.setAttribute('poster', this.lazyPoster?.src);
  }

}
